export type UpdateItem = {
  id: string;
  title: string;
  note: string;
  time: string;
};

export const updateItems: UpdateItem[] = [
  { id: "u-01", title: "岳母的考验", note: "更新至第 78 集", time: "12 分钟前" },
  { id: "u-02", title: "她妈妈不同意", note: "更新至第 65 集", time: "1 小时前" },
  { id: "u-03", title: "准女婿的逆袭", note: "更新至第 82 集", time: "2 小时前" },
  { id: "u-04", title: "岳母驾到", note: "更新至第 40 集", time: "今天 09:20" },
  { id: "u-05", title: "岳母和我的一百天", note: "更新至第 52 集", time: "今天 08:05" },
  { id: "u-06", title: "陪女友回家过年", note: "全 52 集完结", time: "昨天 21:40" },
  { id: "u-07", title: "岳母的眼泪", note: "全 40 集完结", time: "昨天 19:10" },
  { id: "u-08", title: "妈妈的择婿标准", note: "全 44 集完结", time: "昨天 15:30" },
];

export type Character = {
  id: string;
  role: string;
  identity: string;
  trait: string;
  detail: string;
  appears: string;
};

export const characters: Character[] = [
  {
    id: "c-01",
    role: "准女婿",
    identity: "男主",
    trait: "踏实但常好心办错事",
    detail: "成长型角色，负责把观众代入见家长的真实处境，笨拙里带着真诚。",
    appears: "出现于全部 12 部合集",
  },
  {
    id: "c-02",
    role: "岳母 / 准岳母",
    identity: "女方母亲",
    trait: "外在强势，内里柔软",
    detail: "大部分冲突的发起点，择婿标准严格，却常在一顿饭、一句旧事里露出另一面。",
    appears: "出现于 12 部中的 11 部",
  },
  {
    id: "c-03",
    role: "女友 / 女儿",
    identity: "女主",
    trait: "夹在母亲与恋人之间",
    detail: "关系里的润滑剂，负责把两头的话翻译成对方能听懂的样子。",
    appears: "出现于全部 12 部合集",
  },
  {
    id: "c-04",
    role: "岳父",
    identity: "女方父亲",
    trait: "沉默寡言",
    detail: "平时少说话，关键时刻站出来定调，往往是剧情转向的支点。",
    appears: "出现于 8 部合集",
  },
  {
    id: "c-05",
    role: "亲戚团",
    identity: "七大姑八大姨",
    trait: "专业制造话题",
    detail: "饭桌上的提问机器，负责把压力堆到最大，也负责把气氛推向热闹。",
    appears: "出现于 7 部合集",
  },
];

export type Review = {
  id: string;
  drama: string;
  category: string;
  title: string;
  meta: string;
  lead: string;
  body: string;
  image: string;
};

export const reviews: Review[] = [
  {
    id: "r-01",
    drama: "她妈妈不同意",
    category: "冲突反转",
    title: "「不同意」其实是一道选择题",
    meta: "合集观察 · 约 6 分钟阅读",
    lead: "这部剧把反对写成了一个需要全家人一起回答的问题，而不是单纯的坏人桥段。",
    body:
      "开场三集，母亲的反对态度几乎不给余地。但剧情很快把镜头从对立拉回到她自己的处境：她没有自己的退路，只能把全部筹码押在女儿的婚姻上。于是「不同意」不再是单纯的刁难，而是一道选择题——她要的是安全感，男主能给的却是时间。剧集用三年时间线慢慢回答这道题，也让观众跟着重新掂量：反对的背后，往往是一句没说出口的担心。",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20warm%20editorial%20still%20of%20an%20empty%20family%20dining%20room%20at%20dusk%2C%20soft%20amber%20light%20through%20sheer%20curtains%2C%20two%20cups%20of%20tea%20left%20untouched%20on%20a%20wooden%20table%2C%20muted%20terracotta%20and%20cream%20tones%2C%20no%20people%2C%20cinematic%20photography&width=800&height=600&seq=review-drama-01&orientation=landscape",
  },
  {
    id: "r-02",
    drama: "岳母的考验",
    category: "冲突反转",
    title: "从「考验」看家庭剧的套路与破绽",
    meta: "合集观察 · 约 5 分钟阅读",
    lead: "三次考验层层加码，但真正好看的，是第三次考验之后那一段安静的和解。",
    body:
      "考验桥段在这类题材里很常见：故意迟到、假装倒闭、临时加价，套路几乎能背下来。这部剧有意思的地方在于它没有停在过关上，而是让第三次考验的结果反过来指向岳母自己——她安排的每一次试探，都在重复自己当年被挑剔的经历。套路被保留，破绽也被诚实照见，观众看的就不再是谁赢了，而是两个人怎么把话说明白。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20cinematic%20close%20up%20of%20folded%20hands%20resting%20on%20a%20textured%20tablecloth%2C%20soft%20golden%20side%20light%2C%20shallow%20depth%20of%20field%2C%20muted%20beige%20and%20brick%20tones%2C%20no%20faces%2C%20editorial%20still%20life&width=800&height=600&seq=review-drama-02&orientation=landscape",
  },
  {
    id: "r-03",
    drama: "陪女友回家过年",
    category: "温馨日常",
    title: "为什么「回家过年」这一部最能治愈人",
    meta: "合集观察 · 约 4 分钟阅读",
    lead: "它几乎不制造大冲突，靠的全是走亲戚、备年货、守岁这些小事，却让人越看越暖。",
    body:
      "没有反转，也没有撕破脸。七天假期被切成一个个生活片段：贴春联时够不着门框，年夜饭前抢最后一个饺子，初二走亲戚被轮番盘问。男主的成长不是靠一句豪言，而是靠一次次笨拙地把事情做完。治愈感来自细节的真实——观众认得出这些场景，也认得出自己曾经坐过的那张饭桌。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20editorial%20still%20of%20a%20chinese%20new%20year%20table%20with%20red%20envelopes%2C%20tangerines%20and%20paper%20lanterns%2C%20soft%20evening%20light%2C%20muted%20red%20and%20cream%20palette%2C%20no%20people%2C%20cinematic%20photography&width=800&height=600&seq=review-drama-03&orientation=landscape",
  },
];

export type GuideItem = {
  id: string;
  title: string;
  body: string;
};

export const guideItems: GuideItem[] = [
  {
    id: "g-01",
    title: "先看哪一部：给第一次浏览的你",
    body:
      "如果你想快速了解这类题材的节奏，建议从《岳母的第一课》或《第一次见家长》开始，两部的单集时长最短、情节最轻，适合当作入门的观看样本。喜欢强冲突的，可以直接点开《她妈妈不同意》和《岳母的考验》。",
  },
  {
    id: "g-02",
    title: "单集时长与观看节奏",
    body:
      "站内合集的单集时长多在 2 到 3 分钟之间，一部的总集数在 36 到 90 集不等。通勤、午休这类碎片时间适合连看几集；如果只想了解一部剧的走向，可以优先看每部前 3 集和最新更新的一集。",
  },
  {
    id: "g-03",
    title: "怎么用分类和标签找内容",
    body:
      "页面上方的合集区域支持按题材切换：温馨日常偏生活细节，冲突反转偏强情节，家庭伦理偏人物动机，都市情感偏双重身份，逆袭爽感偏低谷翻身。先用分类筛一遍，再结合标签看具体切入点，定位会快很多。",
  },
  {
    id: "g-04",
    title: "关于内容性质的说明",
    body:
      "站内所有短剧均为真人剧情演绎，人物、情节与对白均属虚构创作，用于展现不同家庭关系的相处方式，不对应任何现实中的具体个人或事件。观看时请理性对待剧情设定，区分演绎内容与现实生活。",
  },
];

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const faqItems: FaqItem[] = [
  {
    id: "f-01",
    question: "这个站点具体收录什么内容？",
    answer:
      "站点围绕「女友的妈妈」这一题材，收录岳母、准岳母相关的真人剧情短片与短剧合集，涵盖温馨日常、冲突反转、家庭伦理、都市情感与逆袭爽感等演绎风格，方便你在一个页面里浏览和比较。",
  },
  {
    id: "f-02",
    question: "这些短剧是真实发生的故事吗？",
    answer:
      "不是。所有剧集均为剧情演绎，人物与情节属于虚构创作。站点呈现的是创作视角下的家庭关系，不代表现实中的真实事件或具体个人。",
  },
  {
    id: "f-03",
    question: "怎么快速找到我想看的题材？",
    answer:
      "在上方的合集区域点击题材标签即可筛选，例如点「冲突反转」只看强情节类型，点「温馨日常」只看生活向内容。筛选只作用于本页已收录的条目，切换标签会即时更新列表。",
  },
  {
    id: "f-04",
    question: "更新频率是怎样的？",
    answer:
      "顶部更新条会实时显示各部剧集的更新进度。连载中的合集会持续补充新集，已完结的集会标注总集数；具体节奏以各剧集的更新进度标识为准。",
  },
  {
    id: "f-05",
    question: "内容适合家庭一起看吗？",
    answer:
      "站内内容以家庭关系讨论为主，整体基调偏生活化。不过不同剧集的冲突程度不同，涉及较强情节的条目在标签中有标注，建议按需选择。",
  },
];

export type Topic = {
  id: string;
  name: string;
  count: number;
};

export const topics: Topic[] = [
  { id: "t-01", name: "见家长", count: 9 },
  { id: "t-02", name: "择婿标准", count: 6 },
  { id: "t-03", name: "代际沟通", count: 8 },
  { id: "t-04", name: "家庭阻力", count: 7 },
  { id: "t-05", name: "职场恋情", count: 4 },
  { id: "t-06", name: "春节回家", count: 5 },
  { id: "t-07", name: "同住磨合", count: 6 },
  { id: "t-08", name: "准岳母", count: 11 },
  { id: "t-09", name: "情感反转", count: 7 },
  { id: "t-10", name: "饭后谈心", count: 5 },
];

export type Stat = {
  id: string;
  value: string;
  label: string;
};

export const stats: Stat[] = [
  { id: "s-01", value: "12", label: "收录合集" },
  { id: "s-02", value: "710", label: "累计集数" },
  { id: "s-03", value: "5", label: "演绎题材" },
  { id: "s-04", value: "每日", label: "更新频率" },
];